import { useState } from "react";
import styles from "./dataPolicy.module.scss";

const DataPolicy = ({ onClose, name, type, description, onCancel }) => {
  const [checked, setChecked] = useState(false);
  const [error, setError] = useState("");

  const renderDescription = () => {
    return <div dangerouslySetInnerHTML={{ __html: description }} />;
  };

  const isCheckbox = type === "checkbox";

  const handleContinue = () => {
    if (isCheckbox && !checked) {
      setError("You must agree to the policy before continuing.");
    } else {
      setError("");
      onClose();
    }
  };

  return (
    <div className={styles.dialogStatic}>
      <div className={styles.dialogContent}>
        <h2 className={styles.title}>Please read and agree to continue</h2>

        <div className={styles.description}>{renderDescription()}</div>

        {isCheckbox ? (
          <div className={styles.container}>
            <label className={styles.checkboxContainer}>
              <input
                type="checkbox"
                checked={checked}
                onChange={(e) => setChecked(e.target.checked)}
              />
              I have read and agree to the above policy
            </label>
            {error && <p className={styles.error}>{error}</p>}
            <div className={styles.containerButtons}>
              <button onClick={handleContinue}>Continue</button>
              <button onClick={onCancel} className={styles.closeButton}>
                Cancel
              </button>
            </div>
          </div>
        ) : (
          <div className={styles.containerButtons}>
            <button onClick={onClose}>Okay</button>
            <button onClick={onCancel} className={styles.closeButton}>
              Cancel
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default DataPolicy;
